import React from 'react';
import { GeneratedReportsGrid } from '@pages-clean/shared/generated-reports/generated-reports-grid';
import { IUser } from '@contexts/user-context';

type Props = {
    module: number;
    orgKey: string;
    studyId: string;
    user?: IUser;
};

const GenerationHistory = ({ orgKey, module, studyId, user }: Props) => {
    return <GeneratedReportsGrid orgKey={orgKey} module={module} studyId={studyId} user={user} isGenerationHistory />;
};
export default GenerationHistory;
